import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=fc45a3c2&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc45a3c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc45a3c2')) {
      api.createRecord('fc45a3c2', component.options)
    } else {
      api.reload('fc45a3c2', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=fc45a3c2&scoped=true&", function () {
      api.rerender('fc45a3c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4ROmaAxIODAfs/JS/comp/Accordion.vue"
export default component.exports